// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__37nTu","cell":"styles_cell__lYdy2","title":"styles_title__2UHxr","highlightLeft":"styles_highlightLeft__3uwXg"};